<template>
  <div>
    <component-header
      title="View User"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/user')"
    />
    <b-card>
      <div>
        <div
          v-if="
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER' ||
            this.$currentUserData.category == 'SELLER'
          "
        >
          <div v-if="currentUser.status != 'PENDING'">
            <b-row>
              <b-col md="12">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-row>
                    <b-col md="1">
                      <h4 style="color: #727cf5">Status :</h4>
                    </b-col>
                    <b-col md="4">
                      <eb-select
                        type="select"
                        label="text"
                        id="userStatus"
                        v-model="selectedStatus"
                        placeholder="Select Status"
                        :options="['ACTIVE', 'INACTIVE']"
                        :selected="selectedStatus"
                        @input="changeStatus"
                      ></eb-select>
                    </b-col>
                    <b-col class="text-right">
                      <h4 style="color: #727cf5">Status : {{ currentUser.status }}</h4>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
            <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
          </div>
        </div>
        <h3 class="mx-3" style="color: #727cf5">User Information</h3>
        <b-row>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Full Name :
                <span
                  class="span-text"
                >{{ currentUser.name.first }} {{ currentUser.name.last }}</span>
              </h5>
              <h5 class="h5-text">
                E-mail :
                <span class="span-text">{{ currentUser.authentication.email }}</span>
              </h5>
              <h5 class="h5-text">
                DOB :
                <span class="span-text">{{ currentUser.dob }}</span>
              </h5>
              <h5 class="h5-text">
                Education :
                <span class="span-text">{{ currentUser.education }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Phone Number :
                <span class="span-text">{{ currentUser.authentication.phone }}</span>
              </h5>
              <h5 class="h5-text">
                Gender :
                <span class="span-text">{{ currentUser.gender }}</span>
              </h5>
              <h5 class="h5-text">
                Experience :
                <span class="span-text">
                  {{ currentUser.experience ? currentUser.experience.value : "" }}
                  {{ currentUser.experience ? currentUser.experience.uom : "" }}
                </span>
              </h5>
              <h5 class="h5-text">
                Marital Status :
                <span class="span-text">{{ currentUser.maritalStatus }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5>Profile Photo:</h5>
              <div style="margin-left: 86px; margin-top: -25px">
                <a :href="currentUser.profilePhoto" target="_blank">
                  <img :src="currentUser.profilePhoto" height="100px" width="100px" />
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <h3 class="mx-3" style="color: #727cf5">User Address</h3>
        <b-row>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                City :
                <span class="span-text">{{ currentUser.address.city }}</span>
              </h5>
              <h5 class="h5-text">
                Country :
                <span class="span-text">{{ currentUser.address.country }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                State :
                <span class="span-text">{{ currentUser.address.state }}</span>
              </h5>
              <h5 class="h5-text">
                ZIP Code :
                <span class="span-text">{{ currentUser.address.zip }}</span>
              </h5>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <h3 class="mx-3" style="color: #727cf5">User Access</h3>
        <b-row>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                User Name :
                <span class="span-text">{{ currentUser.authentication.userName }}</span>
              </h5>
              <h5 class="h5-text">
                Category :
                <span class="span-text">{{ currentUser.category }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Access Level :
                <span
                  class="span-text"
                >{{ currentUser.authorization.orgAccess.orgAccessLevel }}</span>
              </h5>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <h3 class="mx-3" style="color: #727cf5">Other Information</h3>
        <b-row>
          <b-col md="12">
            <div class="mx-3">
              <h5 class="h5-text">
                About Me:
                <span class="span-text">{{ currentUser.aboutMe }}</span>
              </h5>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <template>
          <b-button
            size="sm"
            class="mr-2 my -0 main-navigation-button mx-3"
            variant="primary"
            v-b-modal.modal-1
            @click="kycByUser"
          >KYC Details</b-button>
          <b-modal id="modal-1" scrollable size="lg" centered ok-only>
            <b-row v-if="isloading">
              <b-col md="12" class="text-center">
                <h3 style="color: #727cf5">Loading....</h3>
              </b-col>
            </b-row>
            <b-row
              class="px-5 py-2"
              v-else-if="kycUser && kycUser.documents && kycUser.documents.length"
            >
              <b-col
                md="8"
                class="justify-content-center"
                :key="i"
                v-for="(kyc, i) in kycUser.documents"
              >
                <b-row>
                  <h5 class="h5-text">
                    {{ kyc.docType }} :
                    <span class="span-text">{{ kyc.docuementNo }}</span>
                  </h5>
                </b-row>
                <b-row>
                  <h5 class="h5-text">
                    Document Type :
                    <span class="span-text">{{ kyc.docType }}</span>
                  </h5>
                </b-row>
                <b-row>
                  <h5 class="h5-text">Photo :</h5>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <a target="_blank" :href="kyc.frontSideFilePath">
                      <img :src="kyc.frontSideFilePath" height="200px" width="200px" />
                    </a>
                    <label>Front Side</label>
                  </b-col>
                  <b-col md="6">
                    <a target="_blank" :href="kyc.backSideFilePath">
                      <img :src="kyc.backSideFilePath" height="200px" width="200px" />
                    </a>
                    <label>Back Side</label>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col md="12" class="text-center">
                <h3 style="color: #727cf5">Kyc Data Not Found</h3>
              </b-col>
            </b-row>
          </b-modal>
        </template>
      </div>
    </b-card>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import { getReverseGeoCode } from "@/services/geocode";
import cTelInput from "@/components/Common/MobileNumberInput";
import ComponentHeader from "@/components/componentHeader";
import ebSelect from "@/components/FormElements/Select";
import { updateStatus } from "@/services/tenant";
import ebButton from "@/components/FormElements/Button";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Viewuser",
  components: {
    cInput,
    ebButton,
    cTelInput,
    ComponentHeader,
    ebSelect,
  },
  data() {
    return {
      isloading: false,
      currentUser: "",
      selectedStatus: "",
    };
  },
  computed: {
    ...mapGetters({
      kycUser: "tenant/GetKycByUser",
    }),
  },
  methods: {
    changeStatus() {
      this.updateStatus();
    },
    async updateStatus() {
      this.isloading = true;
      try {
        await this.$store.dispatch("tenant/updateStatus", {
          id: this.currentUser._id,
          data: {
            status: this.selectedStatus,
          },
        });
      } catch (err) {}
      this.isloading = false;
    },
    async kycByUser() {
      this.isloading = true;
      const data = await this.$store
        .dispatch("tenant/fetchKYCListByUser", {
          id: this.currentUser._id,
        })
        .then((res) => {});
      this.isloading = false;
    },
  },

  mounted: async function () {
    this.loading = true;
    await this.$store.dispatch("tenant/fetchTenantSubAdminList");
    const allUsersList = this.$store.getters["tenant/GetTenantSubAdminList"];
    this.currentUser = allUsersList.find(
      (user) => this.$route.params.id === user._id
    );
    this.selectedStatus = this.currentUser.status;
    // this.currentUser = this.$route.params.userData;
    this.loading = false;
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
  background-color: aliceblue !important;
}

[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
</style>
<style>
.footer-bottons-class {
  text-align: center;
  background: #727cf5 !important;
  margin-left: 40%;
}
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
.h5-text {
  font-size: 15px;
  line-height: 17px;
}
</style>
